module.exports = __webpack_public_path__ + "img/4.260d7556.jpg";